import { render } from "./WeightmentComponent.vue?vue&type=template&id=0e57cc16"
import script from "./WeightmentComponent.vue?vue&type=script&lang=js"
export * from "./WeightmentComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__